module.exports = __webpack_public_path__ + "img/blog3.31947c41.jpeg";